import React from 'react';
import PropTypes from 'prop-types';
import ReactToggle from 'react-toggle';
import cx from 'classnames';
import './Toggle.less';

/**
 * @deprecated
 *
 * Use [ToggleV2](/?path=/docs/components-togglev2--basic) which is implemented according to updated code standards (TS, css module styling)
 */
const Toggle = ({
  input,
  label,
  labelSide,
  id,
  className,
  inline,
  hasFormGroup,
  disabled,
  withIcons,
  meta: { touched, error },
  ariaLabel,
}) => {
  const inputValue = input.value !== 'false' && input.value;
  const hasError = touched && error;
  const mainClasses = cx('zola-ui', 'zola-ui__toggle-container', className, {
    'zola-ui__toggle-container--inline': inline,
    'form-group': hasFormGroup,
    'has-error': hasError,
  });
  const toggleWrapperClasses = cx({
    'zola-ui__toggle-button-inline': labelSide === 'left' || labelSide === 'right',
  });

  const icons = withIcons
    ? {
        checked: (
          <span className="zola-ui__toggle-option-label">
            <i className="zola-ui-icon zola-ui-icon-checkmark" />
          </span>
        ),
        unchecked: (
          <span className="zola-ui__toggle-option-label">
            <i className="zola-ui-icon zola-ui-icon-close" />
          </span>
        ),
      }
    : null;

  return (
    <div className={mainClasses}>
      {label && (labelSide === 'left' || labelSide === 'top') ? (
        <label htmlFor={id} className="zola-ui__toggle-label">
          {label}
        </label>
      ) : null}
      <div className={toggleWrapperClasses}>
        <ReactToggle
          id={id}
          checked={inputValue}
          disabled={disabled}
          onChange={() => input.onChange && input.onChange(!inputValue)}
          className="zola-ui__toggle"
          icons={icons}
          aria-label={ariaLabel}
        />
      </div>
      {label && labelSide === 'right' ? (
        <label htmlFor={id} className="zola-ui__toggle-label--right">
          {label}
        </label>
      ) : null}
      {hasError ? <span className="zola-ui__help-block">{error}</span> : null}
    </div>
  );
};

Toggle.defaultProps = {
  input: {
    value: false,
    onChange: () => {},
  },
  id: '',
  className: '',
  label: '',
  labelSide: 'left',
  inline: true,
  hasFormGroup: false,
  disabled: false,
  withIcons: false,
  meta: {
    touched: true,
    error: '',
  },
};

Toggle.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOf(['true', 'false', true, false]), // To ensure backwards compatibility with redux-forms
    onChange: PropTypes.func,
  }),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelSide: PropTypes.oneOf(['top', 'left', 'right']),
  id: PropTypes.string,
  className: PropTypes.string,
  inline: PropTypes.bool,
  hasFormGroup: PropTypes.bool,
  disabled: PropTypes.bool,
  withIcons: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  /** For accessibility, use this prop when no labels exist for the input */
  ariaLabel: PropTypes.string,
};

export default Toggle;
